import React from 'react';

type TMousePos = { x: number; y: number };

export function useModal<T extends any>() {
  const [visible, setVisible] = React.useState(false);
  const [mousePosition, setMousePosition] = React.useState<TMousePos | undefined>();
  const [extraData, setExtraData] = React.useState<T>();

  const open = React.useCallback((e?: React.MouseEvent, extraData?: T) => {
    if (e) {
      setMousePosition({
        x: e.pageX,
        y: e.pageY,
      });
    }

    if (extraData) {
      setExtraData(extraData);
    }

    setVisible(true);
  }, []);

  const close = React.useCallback(() => {
    setMousePosition(undefined);
    setExtraData(undefined);
    setVisible(false);
  }, []);

  return { modalProps: { visible, mousePosition }, open, close, data: extraData };
}
